module.exports = __webpack_public_path__ + "static/media/industries-friction-s.73027f58.jpg";